import HeroBg from "public/performanceLabs/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Maximize IT performance with lab-driven validation",
    link: "contact-us",
  },
  title: "High-Performance IT Solutions with Testing Labs",
  desc: "Ensure maximum IT performance with purpose-built labs. Eliminate guesswork, improve reliability, and accelerate deployment with confidence.",
  image: HeroBg,
  cmlPowered: true,
};
